import { connect } from "react-redux";

import { requestData } from "../../../store/data/thunks";
import Content from "./Content";
import { State } from "../../../store/state";

const mapStateToProps = (state: State) => ({
  rowData: state.data.rowData
});

const mapDispatchToProps = {
  requestData
};

const ContentContainer = connect(mapStateToProps, mapDispatchToProps)(Content);

export default ContentContainer;
